import { render, staticRenderFns } from "./DefectGroupQuestionType.vue?vue&type=template&id=3e3aeb80&scoped=true"
import script from "./DefectGroupQuestionType.vue?vue&type=script&lang=js"
export * from "./DefectGroupQuestionType.vue?vue&type=script&lang=js"
import style0 from "./DefectGroupQuestionType.vue?vue&type=style&index=0&id=3e3aeb80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3aeb80",
  null
  
)

export default component.exports